module.exports = __webpack_public_path__ + "assets/img/per-14a361a9.png";